import { RegionType } from '@wix/shoutout-email-model-v3';
import { get } from 'lodash';
import * as cssUtils from '../../utils/css-utils';
import { defaultTextPadding } from '../../utils/defaults';
import { getMessageWidth } from '../../utils/get-message-width';
import { getPxValue } from '../../utils/line-height-to-px';
import { getButton } from './get-button';
import { getText } from './get-text';
export var getItemGridSection = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
    var composerData = _a.composerData, region = _a.region, css = _a.css, experiments = _a.experiments, isRtl = _a.isRtl;
    if (region.type !== RegionType.ItemGrid) {
        throw Error('ItemGrid must be passed');
    }
    var rules = [
        get(region, 'data.styles.region', {}),
        css['so-global-region-mix'],
        css['so-global-region'],
    ];
    var padding = cssUtils.padding(rules);
    var margin = cssUtils.margin(rules);
    var mobileCssClass = cssUtils.getRegionMobileCssClass(rules, true);
    var button = getButton({ css: css, experiments: experiments, isRtl: isRtl, region: region });
    var title = getText({
        css: css,
        isRtl: isRtl,
        region: region,
        cssClass: 'so-global-h3',
        componentStylePath: 'data.styles.title',
        bolden: true,
    });
    var description = getText({
        css: css,
        isRtl: isRtl,
        region: region,
        cssClass: 'so-global-p1',
        componentStylePath: 'data.styles.description',
    });
    var price = getText({
        css: css,
        isRtl: isRtl,
        region: region,
        cssClass: 'so-global-h3',
        componentStylePath: 'data.styles.price',
        bolden: true,
    });
    var verticalSpacing = ((_d = (_c = (_b = region === null || region === void 0 ? void 0 : region.data) === null || _b === void 0 ? void 0 : _b.styles) === null || _c === void 0 ? void 0 : _c.spacings) === null || _d === void 0 ? void 0 : _d.verticalSpacing)
        ? parseInt((_g = (_f = (_e = region === null || region === void 0 ? void 0 : region.data) === null || _e === void 0 ? void 0 : _e.styles) === null || _f === void 0 ? void 0 : _f.spacings) === null || _g === void 0 ? void 0 : _g.verticalSpacing, 10)
        : null;
    var leftColumnPadding = (_k = (_h = (verticalSpacing !== null ? verticalSpacing / 2 : null)) !== null && _h !== void 0 ? _h : (_j = css['so-global-region-mix-left']) === null || _j === void 0 ? void 0 : _j.paddingRight) !== null && _k !== void 0 ? _k : defaultTextPadding;
    var rightColumnPadding = (_o = (_l = (verticalSpacing !== null ? verticalSpacing / 2 : null)) !== null && _l !== void 0 ? _l : (_m = css['so-global-region-mix-right']) === null || _m === void 0 ? void 0 : _m.paddingLeft) !== null && _o !== void 0 ? _o : defaultTextPadding;
    var spacerHeight = parseInt((_s = (_r = (_q = (_p = region === null || region === void 0 ? void 0 : region.data) === null || _p === void 0 ? void 0 : _p.styles) === null || _q === void 0 ? void 0 : _q.spacings) === null || _r === void 0 ? void 0 : _r.horizontalSpacing) !== null && _s !== void 0 ? _s : '12px', 10);
    var fonts = [];
    if (title.fontFamily) {
        fonts.push(title.fontFamily.split(',')[0]);
    }
    if (description.fontFamily) {
        fonts.push(description.fontFamily.split(',')[0]);
    }
    if (price.fontFamily) {
        fonts.push(price.fontFamily.split(',')[0]);
    }
    if (button.fontFamily) {
        fonts.push(button.fontFamily.split(',')[0]);
    }
    var _w = calcWidths(composerData, css, leftColumnPadding, rightColumnPadding, margin, padding), leftColumnWidth = _w.leftColumnWidth, rightColumnWidth = _w.rightColumnWidth;
    return {
        items: region.data.items,
        show: (_t = region.data) === null || _t === void 0 ? void 0 : _t.show,
        buttonLabel: (_u = region.data) === null || _u === void 0 ? void 0 : _u.buttonLabel,
        layout: (_v = region.data) === null || _v === void 0 ? void 0 : _v.layout,
        cssClass: mobileCssClass,
        innerPadding: padding,
        outerPadding: margin,
        leftColumnPadding: getPxValue(leftColumnPadding),
        rightColumnPadding: getPxValue(rightColumnPadding),
        leftColumnWidth: leftColumnWidth,
        rightColumnWidth: rightColumnWidth,
        spacerHeight: spacerHeight,
        button: button,
        title: title,
        description: description,
        price: price,
        fonts: fonts,
    };
};
function calcWidths(composerData, css, leftColumnPadding, rightColumnPadding, margin, padding) {
    var messageContentWidth = getMessageWidth(composerData, css);
    var parsedLeftColumnPadding = parseInt(leftColumnPadding.toString(), 10);
    var parsedRightColumnPadding = parseInt(rightColumnPadding.toString(), 10);
    var availableSpace = messageContentWidth - (((margin === null || margin === void 0 ? void 0 : margin.left) || 0) + ((margin === null || margin === void 0 ? void 0 : margin.right) || 0));
    var paddingSpace = parsedLeftColumnPadding + parsedLeftColumnPadding;
    var contentSpace = availableSpace -
        ((padding.right || 0) + (padding.left || 0)) -
        paddingSpace;
    var spaceForColumn = contentSpace / 2;
    var leftColumnWidth = ((spaceForColumn + parsedRightColumnPadding + (padding.left || 0)) * 100) /
        availableSpace + "%";
    var rightColumnWidth = ((spaceForColumn + parsedLeftColumnPadding + (padding.right || 0)) * 100) /
        availableSpace + "%";
    return { leftColumnWidth: leftColumnWidth, rightColumnWidth: rightColumnWidth };
}
//# sourceMappingURL=get-item-grid-section.js.map